import { ReactNode, useState } from 'react'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from 'Root/App/Button'
import Title from 'Root/App/Title'

import styles from './index.module.css'

library.add(faChevronDown, faChevronUp)

interface AccordionProps {
  children: ReactNode
  title: string
  titleCustomClass?: string
  onOpen?: () => void
}

const Accordion = ({
  children,
  title,
  titleCustomClass,
  onOpen,
}: AccordionProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOnClick = () => {
    onOpen && !isOpen && onOpen()
    setIsOpen((prevIsOpen) => !prevIsOpen)
  }

  return (
    <div>
      <div className={styles.accordionWrapper} onClick={handleOnClick}>
        <Title className={`w-full ${titleCustomClass}`}>{title}</Title>

        <Button
          icon={
            <FontAwesomeIcon
              icon={['fas', isOpen ? 'chevron-up' : 'chevron-down']}
              className={styles.accordionIcon}
            />
          }
          className="bg-transparent"
          subtype="circle"
          size="XS"
        />
      </div>
      {isOpen && children}
    </div>
  )
}

export default Accordion
